import React from 'react'
import Experiment from '@mc/experiments-react'
import { QuizStickyFooterCopy } from '../../../components/QuizStickyFooterCopy'
import { EXPERIMENT_FLAG_KEY } from '../constants'
import { useExperimentCriteria } from '../hooks/useExperimentCriteria'
import { Pen5108GiftNowCta, Pen5108GiftNowCtaProps } from './Pen5108GiftNowCta'

interface Pen5108CtaContentWrapperProps extends Pen5108GiftNowCtaProps {
  control?: React.ReactNode
}

export const Pen5108CtaContentWrapper = ({
  control,
  query,
  location,
  CTA,
}: Pen5108CtaContentWrapperProps) => {
  const { experimentCriteria } = useExperimentCriteria()
  if (!experimentCriteria) return control

  return (
    <Experiment
      name={EXPERIMENT_FLAG_KEY}
      control={() => control}
      variant_1={() => (
        <div className='mc-mt-4'>
          <div className='d-flex align-items-center justify-content-center mc-py-2'>
            <QuizStickyFooterCopy />
          </div>
          <div className='mc-mt-4' />
          <Pen5108GiftNowCta location={location} query={query} CTA={CTA} />
        </div>
      )}
      track={false}
    />
  )
}
